<template>
	<div class="arrow" v-on:click="$emit('click')" :class="direction">
		<svg v-if="direction == 'left'" style="enable-background:new 0 0 512 512;" viewBox="0 0 512 512" :width="`${width}px`" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><polygon points="352,128.4 319.7,96 160,256 160,256 160,256 319.7,416 352,383.6 224.7,256 "></polygon></svg>
		<svg v-if="direction == 'right'" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" :width="`${width}px`" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><polygon points="160,128.4 192.3,96 352,256 352,256 352,256 192.3,416 160,383.6 287.3,256 "></polygon></svg>
	</div>
</template>

<script>
export default {
  props: {
    direction: {
      type: String,
      default: 'left'
    },
    width: {
      type: Number,
      default: 50
    }
  }
}
</script>
